import React from 'react';
import { Redirect } from 'react-router';

import { useAuth } from '../../../context/AuthContext';
import Spinner from '../../UI/Spinner';

const InitialRedirect: React.FC = () => {
  const { authStatus, loading } = useAuth();

  if (loading) return <Spinner fullscreen />;

  return <Redirect to={authStatus ? '/tabs/home' : '/auth'} />;
};

export default InitialRedirect;
